<template>
  <div class="checkout-canceled-view">
    <div>
      <div class="checkout-canceled-view__icon">⚠️</div>
      <h1>{{ $t("headings.orderIncomplete") }}</h1>
      <p class="checkout-canceled-view__text">
        {{ $t("texts.orderCanceled") }}
      </p>

      <router-link :to="{ name: 'settings-subscriptions' }" class="button mt-4">
        {{ $t("links.toSubscriptions") }}
      </router-link>
    </div>
  </div>
</template>

<style lang="scss">
.checkout-canceled-view {
  max-width: 40rem;
  margin: auto;
  background-color: var(--color-background-deep);
  padding: 3rem;
  border-radius: 2rem;
  text-align: center;

  &__text {
    font-size: 16px;
    line-height: 1.5;
  }

  &__icon {
    font-size: 4rem;
    text-align: center;
  }
}
</style>